import { render, staticRenderFns } from "./CoursePageDesktopPreview.vue?vue&type=template&id=39f238c8&scoped=true"
import script from "./CoursePageDesktopPreview.vue?vue&type=script&lang=js"
export * from "./CoursePageDesktopPreview.vue?vue&type=script&lang=js"
import style0 from "./CoursePageDesktopPreview.vue?vue&type=style&index=0&id=39f238c8&prod&lang=scss&scoped=true"
import style1 from "./CoursePageDesktopPreview.vue?vue&type=style&index=1&id=39f238c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f238c8",
  null
  
)

export default component.exports